export const getExecutionAchievementNotifications = (state) =>
  (state.executionAchievements?.notificationQueue || []).filter(
    (t) => !["NO_REPEAT_SEQUENCE", "NO_LISTEN_SEQUENCE", "REPEAT_USAGE_TIP", "LISTEN_USAGE_TIP"].some((x) => t === x)
  );

export const getExecutionHelpNotifications = (state) =>
  (state.executionAchievements?.notificationQueue || []).filter((t) =>
    ["NO_REPEAT_SEQUENCE", "NO_LISTEN_SEQUENCE", "REPEAT_USAGE_TIP", "LISTEN_USAGE_TIP"].some((x) => t === x)
  );
